import React, { useEffect } from "react";
import {
    Modal,
    Button,
    ModalBody,
    ModalFooter,
    ModalHeader,
    FormGroup,
    Label,
    Input
} from "reactstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomInput from "./customInput";
import { updateVoucherStatus } from "../../redux/actions/voucherActions";


const statusOptions = ["Approved", "Rejected", "Pending", "Sold"];

const validationSchema = yup.object().shape({
    voucherId: yup.string().required("Voucher ID is required"),
    actualPrice: yup.number().typeError("Actual Price must be a number").required("Actual Price is required"),
    sellingPrice: yup.number().typeError("Selling Price must be a number").required("Selling Price is required"),
    description: yup.string().required("Description is required"),
    status: yup.string().required("Status is required"),
    // brandname: yup.string().required("Brand Name is required"),
});

const EditVoucher = ({ openModal, onCloseModal, voucher, triggerGetList }) => {
    const dispatch = useDispatch();

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            voucherId: "",
            actualPrice: "",
            sellingPrice: "",
            description: "",
            status: "",
            isDisabled: false,
            // brandname: "",
        },
    });

    useEffect(() => {
        if (voucher) {
            setValue("voucherId", voucher.voucherId);
            setValue("actualPrice", voucher.actualPrice);
            setValue("sellingPrice", voucher.sellingPrice);
            setValue("description", voucher.description);
            setValue("status", voucher.status);
            setValue("isDisabled", voucher.isDisabled); 
        }
    }, [voucher, setValue]);

    const onSubmit = async (data) => {
        try {
            const updatedData = { ...data };
            await dispatch(updateVoucherStatus(voucher.voucherId, updatedData));
            // toast.success("Voucher details updated successfully!");
            onCloseModal();
            triggerGetList();
        } catch (error) {
            toast.error("Failed to update status.");
        }
    };

    return (
        <Modal isOpen={openModal} toggle={onCloseModal}>
            <ModalHeader toggle={onCloseModal}>
                <h5 className="modal-title f-w-600">Edit Voucher</h5>
            </ModalHeader>
            <ModalBody>
                <form onSubmit={handleSubmit(onSubmit)}>
                    {/* Voucher ID */}
                    <CustomInput
                        fieldLabel="Voucher ID:"
                        control={control}
                        error={errors.voucherId}
                        fieldName="voucherId"
                        disabled
                    />

                    {/* Actual Price */}
                    <CustomInput
                        fieldLabel="Actual Price:"
                        control={control}
                        error={errors.actualPrice}
                        fieldName="actualPrice"
                        type="number"
                    />

                    {/* Selling Price */}
                    <CustomInput
                        fieldLabel="Selling Price:"
                        control={control}
                        error={errors.sellingPrice}
                        fieldName="sellingPrice"
                        type="number"
                    />

                    {/* Description */}
                    <CustomInput
                        fieldLabel="Description:"
                        control={control}
                        error={errors.description}
                        fieldName="description"
                    />

                    {/* Status Dropdown */}
                    <FormGroup>
                        <Label>Status:</Label>
                        <Controller
                            name="status"
                            control={control}
                            render={({ field }) => (
                                <Input type="select" {...field}>
                                    {statusOptions.map((option) => (
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    ))}
                                </Input>
                            )}
                        />
                        {errors.status && <p className="text-danger">{errors.status.message}</p>}
                    </FormGroup>

                    {/* Brand Name */}
                    {/* <CustomInput
                        fieldLabel="Brand Name:"
                        control={control}
                        error={errors.brandname}
                        fieldName="brandname"
                    /> */}

                    {/* Disable Checkbox */}
                    <FormGroup check>
                        <Controller
                            name="isDisabled"
                            control={control}
                            render={({ field }) => (
                                <Input type="checkbox" checked={field.value} onChange={(e) => field.onChange(e.target.checked)} />
                            )}
                        />
                        <Label className="pl-2">Disable</Label>
                    </FormGroup>
                </form>
            </ModalBody>
            <ModalFooter>
                <Button type="submit" color="primary" onClick={handleSubmit(onSubmit)}>
                    Save
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default EditVoucher;
